import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appAllowedChars]'
})
export class AllowedCharsDirective {

  // Default enterprise-safe pattern
  @Input() allowedPattern: RegExp = /[^a-zA-Z ._@'-]/g;

  @HostListener('input', ['$event'])
  onInputChange(event: any): void {
    const initialValue = event.target.value;

    const cleanedValue = initialValue.replace(this.allowedPattern, '');

    if (initialValue !== cleanedValue) {
      event.target.value = cleanedValue;
      event.target.dispatchEvent(new Event('input'));
    }
  }
}